import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { MdOutlineQuiz } from 'react-icons/md'
import { IoStorefrontOutline } from 'react-icons/io5'
import { AiOutlineBook } from 'react-icons/ai'
import { RiBookletLine } from 'react-icons/ri'

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";
import { Link } from 'react-router-dom';

const Projects = () => {
    return (
        <div className=' mt-8'>
            <h1 className=' text-center p-4 text-4xl font-semibold '>Projects</h1>
            <Swiper
                slidesPerView={3}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper"
            >
                <div className=''>
                    <SwiperSlide>

                        <div className="flex flex-col justify-between p-5 border rounded shadow-sm lg:w-96 bg-stone-300">
                            <div>
                                <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full">
                                    <MdOutlineQuiz className="w-8 h-8"></MdOutlineQuiz>

                                </div>
                                <h6 className="mb-2 font-semibold leading-5">Brainless Quiz</h6>
                                <p className="mb-3 text-sm text-gray-900">
                                    Rough pomfret lemon shark plownose chimaera southern sandfish
                                    kokanee northern sea.
                                </p>
                            </div>
                            <Link
                                to='/brainless'
                                className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
                            >
                                Learn more
                            </Link>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="flex flex-col justify-between p-5 border rounded shadow-sm lg:w-96 bg-stone-300">
                            <div>
                                <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full ">
                                    <IoStorefrontOutline className="w-8 h-8"></IoStorefrontOutline>
                                </div>
                                <h6 className="mb-2 font-semibold leading-5">Car Portal</h6>
                                <p className="mb-3 text-sm text-gray-900">
                                    Rough pomfret lemon shark plownose chimaera southern sandfish
                                    kokanee northern sea.
                                </p>
                            </div>
                            <Link
                                to='/carportal'
                                className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
                            >
                                Learn more
                            </Link>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="flex flex-col justify-between p-5 border rounded shadow-sm lg:w-96 bg-stone-300">
                            <div>
                                <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full ">
                                    <AiOutlineBook className="w-8 h-8"></AiOutlineBook>
                                </div>
                                <h6 className="mb-2 font-semibold leading-5">Book Store</h6>
                                <p className="mb-3 text-sm text-gray-900">
                                    Rough pomfret lemon shark plownose chimaera southern sandfish
                                    kokanee northern sea.
                                </p>
                            </div>
                            <Link
                                to='/book'
                                className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
                            >
                                Learn more
                            </Link>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="flex flex-col justify-between p-5 border rounded shadow-sm lg:w-96 bg-stone-300">
                            <div>
                                <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full">
                                    <RiBookletLine className="w-8 h-8"></RiBookletLine>
                                </div>
                                <h6 className="mb-2 font-semibold leading-5">When has justice</h6>
                                <p className="mb-3 text-sm text-gray-900">
                                    Rough pomfret lemon shark plownose chimaera southern sandfish
                                    kokanee northern sea.
                                </p>
                            </div>
                            <Link
                                to='/brainless'
                                className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
                            >
                                Learn more
                            </Link>
                        </div>
                    </SwiperSlide>
                </div>
            </Swiper>
        </div>
    );
};

export default Projects;